import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgentBio.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from './SalespersonSidebar';


const AgentBio = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [bioDetails, setBioDetails] = useState(true);
    const [clientsRepresented, setClientsRepresented] = useState(true);
    const [certifications,  setCertifications] = useState({});
    const [errortext,  setErrorText] = useState('');
  
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const {slug} = useParams();

    const agent = {
        firstName:'Jeff',
        lastName:'Brodie',
        image:'/images/jeff-brodie.jpg',
        title:'SMWW Agent Advisor',
        location:'Portland, Oregon, United States',
        socialMedia:'https://www.linkedin.com/in/jeff-brodie-71004914/',
        email:'jeff@smww.com',
    }

   

    const clients = [
        {
            name: 'Blake Brandel',
            image: '/images/blake-brandel.png',
            url: '/athlete/blake-brandel',
            position: 'Offensive Lineman'
        }
  ];

    

    useEffect(() => {
        Promise.all([
            retrieveAgentBioDetails(),
            retrieveClientsRepresented(),
            retrieveCertifications()
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);
 async function retrieveAgentBioDetails() {
    if(slug) {
       try {
        
    const response = await fetch(
      app_url+'smwwagency/getagentbiodetails?slug='+slug,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setBioDetails(responsedata.data.result);
    }
    if(responsedata.data.msg === "Error") {
      setErrorText(responsedata.data.result);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }
  async function retrieveClientsRepresented() {
    if(slug) {
       try {
        
    const response = await fetch(
      app_url+'smwwagency/getclientsrepresented?slug='+slug,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setClientsRepresented(responsedata.data.result);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }
    async function retrieveCertifications() {
    if(slug) {
       try {
        
    const response = await fetch(
      app_url+'smwwagency/getcertifications?slug='+slug,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setCertifications(responsedata.data.result);
    }
    } catch (error) {
        console.error(error);
      }finally {
             // Set loading to false after fetch completes (success or error)
          }
  }
  }
    return (
        <>
        {isLoading ? (
            <Loading />
        ) : (
            <div id="main" className="three-column-layout">
                <Helmet><title>{bioDetails.meta_title}</title></Helmet>
                {(Object.keys(certifications).length > 0 || clientsRepresented.length > 0 ) &&  (
                    <>
                 <div className="left">
                    <div>
                       
                           {Object.keys(certifications).length > 0 &&  (
                                <> <div className="agent-block">
                            <h2>Certifications</h2>
                            <div className="">
           {Object.keys(certifications).map((key) => (                     
    <div className="successboxx" key={key}>
      <ul>
        <li>{certifications[key]}</li>
      </ul>
    </div>
      ))}
     </div></div></>
                           )}
                                
                           
                        
                       
 {clientsRepresented.length > 0 && (
    <> <div className="agent-block">
                            <h2>Clients Represented</h2>
 {clientsRepresented.map((client, index) => (
                            <div className="">
                                <div className="view view-agents view-id-agents des-agents-wrapper">
                                    <div className="view-content">
                                       
                                            <div className="item-list agents-wrapper img-wrapper" key={index}>
                                                <ul>
                                                    <li>
                                                        <div className="views-field-picture">
                                                            <div className="field-content">
                                                                <img
                                                                    className="lazyloaded"
                                                                    width="193px"
                                                                    height="158px"
                                                                    src={client.image}
                                                                    alt={client.name}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="views-field-last-name">
                                                            <div className="field-content">
                                                                <a
                                                                    style={{ color: '#003c7d', fontSize: '18px' }}
                                                                    href={client.url}
                                                                >
                                                                    {client.name}
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="views-field-agent-biography text">
                                                            <div className="field-content">
                                                                <ul>
                                                                    <li>{client.position}</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                       
                                    </div>
                                </div>
                            </div>
                             ))}
                            </div>
                            </>
                             )}
                        
                    </div>
                </div></>
                           
                )}
                <div className={(Object.keys(certifications).length > 0 || clientsRepresented.length > 0) ? 'center' : 'center left-center'}>
                {errortext ? (
                        <><div dangerouslySetInnerHTML={{ __html: errortext }}></div></>
                ) : (
                    <>
                    <div className="agent-newbio-container">
                        <table className="agent_image_section">
                            <tbody>
                                <tr>
                                    <td className="mobile-agent-bio-img">
                                        <div className="agent_image_container">
                                            <img className="agent-round-img" src={bioDetails.picture} />
                                        </div>
                                    </td>
                                    <td className="mobile-agent-bio-name">
                                        <div className="agent-bio-name">{bioDetails.name && bioDetails.name}</div>
                                        <div className="user_title">{bioDetails.agent_title && bioDetails.agent_title}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="agent-moible-hr"></div>
                        <div className="agent-location">
                            <div><b>Location:</b>{bioDetails.location && bioDetails.location}</div>
                        </div>
                        {bioDetails.qa && (
                         <div className="agent-qa">
                            <div dangerouslySetInnerHTML={{ __html: bioDetails.qa }}></div>
                        </div>
                        )}
                         {bioDetails.field_agent_biography && (
                        <><div className="agent-heading-wrapper">
                            <h2>Biography</h2>
                        </div>
                        <div className="agent-moible-hr"></div>
                            <div className="agent-bio-container">
                               
                            <div dangerouslySetInnerHTML={{ __html: bioDetails.field_agent_biography }}></div>
                            
                            </div></>
                        )}
                         {bioDetails.field_education && (
                        <>
                            <div className="agent-heading-wrapper">
                                <h2>Education</h2>
                            </div>
                            <div className="agent-moible-hr"></div>
                            <div className="agent-career-container">
                               <div dangerouslySetInnerHTML={{ __html: bioDetails.field_education }}></div>
                            </div>
                        </>
                        )}
                         {(bioDetails.field_instagram_url  || bioDetails.field_instagram_handle  || bioDetails.field_facebook_url  || bioDetails.field_facebook_handle 
                         || bioDetails.field_twitter_url  || bioDetails.field_user_youtube_url  || bioDetails.field_linkedin_url  || bioDetails.field_linkedin_handle ) && (
                            <><div className="agent-heading-wrapper">
                                <h2>Social Media</h2>
                            </div>
                            <div className="agent-moible-hr"></div>
                            <div className="mobile-agent-sm-container">
                                {bioDetails.field_instagram_url && (
                                <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                  <img src="/basic/web/images/instagram_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                         
                                            <div >
                                                
                                                <a href={bioDetails.field_instagram_url}>{bioDetails.field_instagram_handle}</a>
                                            </div>
                                              
                                     </div>
                                </div>
                                )}
                                {bioDetails.field_twitter_url && (
                                <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                   <img src="/basic/web/images/twitter_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            
                                        
                                            <div >
                                               
                                                <a href={bioDetails.field_twitter_url}>{bioDetails.field_twitter_handle}</a>
                                            </div>
                                    </div>
                                </div>   
                                    
                                   )}
                                   {bioDetails.field_linkedin_url && (
                                    <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                  <img src="/basic/web/images/linkedin_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                                
                                                <a href={bioDetails.field_linkedin_url}>{bioDetails.field_linkedin_handle}</a>
                                            </div>
                                     </div>
                                </div>     
                                   
                                   )}
                                   {bioDetails.field_facebook_url && (
                                   <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                  <img src="/basic/web/images/facebook_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                                
                                                <a href={bioDetails.field_facebook_url}>{bioDetails.field_facebook_handle}</a>
                                            </div>
                                       </div>
                                </div>     
                                  
                                   )}
                                   {bioDetails.field_user_youtube_url && (
                                     <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                   <img src="/basic/web/images/youtube_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                               
                                                <a href={bioDetails.field_user_youtube_url}>{bioDetails.field_user_youtube_handle}</a>
                                            </div>
                                    </div>
                                     </div>     
                                    
                                   )}
                                    </div>
                                 
                                   
                               </>
                         )}
                        {bioDetails.field_how_to_contact_client && (
                        <>
                        <div className="agent-heading-wrapper">
                            <h2>How to Contact</h2>
                        </div>
                        <div className="agent-moible-hr"></div>
                        <div style={{fontSize:"15px",margin:"1em 0",marginBottom:"0px",lineHeight: "20px"}}>
                            <div dangerouslySetInnerHTML={{ __html: bioDetails.field_how_to_contact_client }}></div>
                        </div>
                         </>
                        )}
                    </div>
                    </>
                    )}
                    <div className="mob-agents-wrapper">
                        {Object.keys(certifications).length > 0 &&  (
                        <div className="agent-block">
                            <h2>Certifications</h2>
                            <div className="">
                                 {Object.keys(certifications).map((key) => (
    <div className="successboxx" key={key}>
      <ul>
        <li>{certifications[key]}</li>
      </ul>
    </div>
  ))}
                                
                            </div>
                        </div>
                        )}
                        {clientsRepresented.length > 0 && (
                        <div className="agent-block">

                            <h2>Clients Represented</h2>

                            <div className="">
                                <div className="view view-agents view-id-agents des-agents-wrapper">
                                    <div className="view-content">
                                       {clientsRepresented.map((client, index) => (
                                            <div className="item-list agents-wrapper img-wrapper" key={index}>
                                                <ul>
                                                    <li>
                                                        <div className="views-field-picture">
                                                            <div className="field-content">
                                                                <img
                                                                    className="lazyloaded"
                                                                    width="193px"
                                                                    height="158px"
                                                                    src={client.image}
                                                                    alt={client.name}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="views-field-last-name">
                                                            <div className="field-content">
                                                                <a
                                                                    style={{ color: '#003c7d', fontSize: '18px' }}
                                                                    href={client.url}
                                                                >
                                                                    {client.name}
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="views-field-agent-biography text">
                                                            <div className="field-content">
                                                                <ul>
                                                                    <li>{client.position}</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}
		            </div>
		            <div></div>
                </div>
                <div className="right">
                    <AgencySidebar/>
                    <SalespersonSidebar />
                </div>
            </div>
        )}
        </>
    );
};
export default AgentBio;